import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetJson } from '../helpers/fetchReact';
import { REST_API } from '../constants';
import { STATE_STATUS } from '../constants';
import { isValueEmpty, isJsonString } from '@awp/helpers/utilsReact';

const initialState = {
  sensorstatuses: [],
  sensorstatus: {},
  sensorstatusLoading: STATE_STATUS.IDLE,
  sensorstatusError: null,

  sensormodels: [],
  sensormodel: {},
  sensormodelLoading: STATE_STATUS.IDLE,
  sensormodelError: null,
};

export const selectAllSensorstatuses = (state) => state.sensorEquipment.sensorstatuses;
export const selectSensorstatusId = (state) => state.sensorEquipment.sensorstatus.Id;
export const selectAllSensormodels = (state) => state.sensorEquipment.sensormodels;
export const selectSensormodelId = (state) => state.sensorEquipment.sensormodel.Id;

export const getSensorstatusLoading = (state) => state.sensorEquipment.sensorstatusLoading;
export const getSensormodelLoading = (state) => state.sensorEquipment.sensormodelLoading;

export const fetchSensorstatuses = createAsyncThunk(
  'sensorEquipment/fetchSensorstatuses',
  async () => {
    const url = REST_API.SENSOR_EQUIPMENT + 'sensorstatuses';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { sensorEquipment: state } = getState();
      return state.sensorstatusLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchSensormodels = createAsyncThunk(
  'sensorEquipment/fetchSensormodels',
  async () => {
    const url = REST_API.SENSOR_EQUIPMENT + 'sensormodels';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { sensorEquipment: state } = getState();
      return state.sensormodelLoading !== STATE_STATUS.LOADING;
    },
  },
);

export const sensorEquipmentSlice = createSlice({
  name: 'sensorEquipment',
  initialState,
  reducers: {
    setSensorstatus(state, action) {
      state.sensorstatus = action.payload;
    },
    setSensormodel(state, action) {
      state.sensormodel = action.payload;
    },
  },
  extraReducers: {
    [fetchSensorstatuses.pending]: (state) => {
      state.sensorstatusLoading = STATE_STATUS.LOADING;
    },
    [fetchSensorstatuses.fulfilled]: (state, action) => {
      state.sensorstatusLoading = STATE_STATUS.SUCCESS;

      state.sensorstatuses = action.payload;
      if (isValueEmpty(state.sensorstatus) || state.sensorstatus.Id < 1) {
        let defaultStatus = state.sensorstatuses.find((s) => (s.Name + '').toLowerCase() == 'inactive');
        state.sensorstatus = { ...defaultStatus };
      }
    },
    [fetchSensorstatuses.rejected]: (state, action) => {
      state.sensorstatusLoading = STATE_STATUS.FAILED;
      state.sensorstatusError = action.error.message;
    },

    [fetchSensormodels.pending]: (state) => {
      state.sensormodelLoading = STATE_STATUS.LOADING;
    },
    [fetchSensormodels.fulfilled]: (state, action) => {
      state.sensormodelLoading = STATE_STATUS.SUCCESS;
      state.sensormodels = action.payload;
    },
    [fetchSensormodels.rejected]: (state, action) => {
      state.sensormodelLoading = STATE_STATUS.FAILED;
      state.sensormodelError = action.error.message;
    },
  },
});

//for multi-lanes json schema and update json of sensor
export const getjsonObject = (_sensor, sensorModelList) => {
  let sensor = { ..._sensor };
  if (!sensor) return null;
  let sensorJsonObj =
    sensor && !isValueEmpty(sensor.StructuredAttributes) && isJsonString(sensor.StructuredAttributes)
      ? JSON.parse(sensor.StructuredAttributes)
      : null;
  if (sensor.ModelId < 1) return sensorJsonObj;
  const st = sensorModelList.find((opt) => opt.Id == sensor.ModelId);
  let stJsonObj =
    st && !isValueEmpty(st.SensorAttributeSchema) && isJsonString(st.SensorAttributeSchema)
      ? JSON.parse(st.SensorAttributeSchema)
      : null;
  if (!stJsonObj || !stJsonObj.properties || stJsonObj.properties.length === 0) return null;
  if (isValueEmpty(sensorJsonObj) && !isValueEmpty(stJsonObj)) return stJsonObj;
  Object.keys(stJsonObj.properties).map((p, i) => {
    if (isValueEmpty(p) || isValueEmpty(sensorJsonObj) || isValueEmpty(sensorJsonObj.properties)) return;
    stJsonObj.properties[p].value =
      sensorJsonObj && sensorJsonObj.properties[p] ? sensorJsonObj.properties[p].value : null;
    if (
      !isValueEmpty(stJsonObj) &&
      !isValueEmpty(stJsonObj.properties[p]) &&
      !isValueEmpty(stJsonObj.properties[p].enum) &&
      stJsonObj.properties[p].enum.length > 0 &&
      !isValueEmpty(stJsonObj.properties[p].value) &&
      !stJsonObj.properties[p].enum.includes(stJsonObj.properties[p].value)
    )
      stJsonObj.properties[p].value = null;
  });
  return stJsonObj;
};
export const { setSensorstatus, setSensormodel } = sensorEquipmentSlice.actions;
